var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3h10.452V5.1H0v10.2zm1.161-9.067h8.13v7.934H1.16V6.233zm16.669-.967a.59.59 0 00-.821 0l-1.332 1.3v-2.6C15.677 1.78 13.854 0 11.613 0H9.87c-.32 0-.58.254-.58.567 0 .312.26.566.58.566h1.742c1.6 0 2.903 1.271 2.903 2.834v2.598l-1.331-1.299a.59.59 0 00-.821 0 .557.557 0 000 .801l2.322 2.267a.586.586 0 00.821 0l2.323-2.267a.557.557 0 000-.801z"
  })));
}
export default SvgRotateRight;